import {Box, Center, Flex, Icon, Image, Text} from '@chakra-ui/react'
import {
  Step,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
} from '@chakra-ui/react'

import CheckActiveIcon from '@assets/svgs/learn/check_active.svg'
import CheckCompleteIcon from '@assets/svgs/learn/check_complete.svg'
import ArrowLeft2 from '@assets/svgs/learn/arrow_left_2.svg'
import {ReactComponent as ArrowRight4} from '@assets/svgs/learn/arrow_right_4.svg'

import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {Modal} from 'antd'
import useExamRoom from './useExamRoom'
import {useDispatch, useSelector} from 'react-redux'
import {updateIsShowHeaderBtn} from '@redux/revise/revise'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import {updateIsShowReportErrorForm} from '@redux/shared/shared'
import {PATH} from '@utils/Const'

const Header = ({
  dataQuestions,
  currentLevelIndex,
  currentQuestionIndex,
  setCurrentLevelIndex,
  setCurrentQuestionIndex,
}: any) => {
  const {currentQuestion, isShowHeaderBtn, statusHeaderBtn} = useSelector(
    (state: any) => state.revise,
  )
  const location = useLocation()
  const {handlePauseAudio} = useExamRoom()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [indexProgress, setIndexProgress] = useState<number>(0)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {entry_point} = location.state || {}

  useEffect(() => {
    const i = dataQuestions?.progresses.indexOf(currentQuestion?.progress)
    setIndexProgress(i)
  }, [currentQuestion])

  const handleOpenModal = () => {
    setIsOpenModal(true)
  }

  const handleCancelModal = () => {
    setIsOpenModal(false)
  }

  const handleOke = () => {
    navigate(PATH.LEARN_REVISE)
  }

  const getTextBtn = () => {
    if (
      currentQuestion?.type === 'LV2_LISTEN_CONVERSATION' ||
      currentQuestion?.type === 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
    ) {
      return {
        text: statusHeaderBtn === 'complete' ? 'Hoàn thành' : 'Bỏ qua',
        color: statusHeaderBtn === 'complete' ? 'white' : '#8C8C8C',
        bg:
          statusHeaderBtn === 'complete'
            ? 'linear-gradient(174deg, #FFC531 4.83%, #FF9500 95.23%)'
            : 'white',
      }
    }
    if (
      currentQuestion?.type === 'LV1_LISTEN_AND_CHOOSE' ||
      currentQuestion?.type === 'LV1_SPEAKING'
    ) {
      return {
        text:
          dataQuestions.questions[currentLevelIndex].length ===
          currentQuestionIndex + 1
            ? 'Hoàn thành'
            : 'Tiếp  tục',
        color: currentQuestion.type === 'skip' ? '#8C8C8C' : 'white',
        bg:
          dataQuestions.questions[currentLevelIndex].length ===
          currentQuestionIndex + 1
            ? 'linear-gradient(174deg, #FFC531 4.83%, #FF9500 95.23%)'
            : '#1890FF',
      }
    }
  }

  const handleClickBtn = () => {
    if (
      currentLevelIndex === dataQuestions.questions.length - 1 &&
      currentQuestionIndex ===
        dataQuestions.questions[currentLevelIndex].length - 1
    ) {
      const phrase_bucket_ids = dataQuestions?.phrase_bucket_ids.join()
      navigate(PATH.LEARN_REVISE_ROOM_COMPLETE, {
        state: {
          phrase_bucket_ids,
          entry_point,
        },
      })
      return
    }

    if (
      currentQuestionIndex ===
      dataQuestions.questions[currentLevelIndex].length - 1
    ) {
      setCurrentLevelIndex((pre: any) => pre + 1)
      setCurrentQuestionIndex(0)
    } else {
      setCurrentQuestionIndex((pre: any) => pre + 1)
    }
    dispatch(updateIsShowHeaderBtn(false))
    handlePauseAudio()
  }

  return (
    <Box>
      <Center fontSize={'24px'} fontWeight={600} pt={'40px'} color={'#003D75'}>
        Ôn tập kiến thức
      </Center>
      <Flex
        mx={'34px'}
        mt={'16px'}
        justifyContent={'center'}
        position={'relative'}>
        <Center
          position={'absolute'}
          left={0}
          w={'48px'}
          h={'48px'}
          bg={'white'}
          borderRadius={'50%'}
          cursor={'pointer'}
          shadow={
            '0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)'
          }
          _hover={{
            shadow: '0px 4px 8px 0px #ccc, 0px 2px 4px 0px #ccc',
          }}
          onClick={handleOpenModal}>
          <Image src={ArrowLeft2} />
        </Center>
        <Box
          flex={1}
          maxW={'600px'}
          display={{base: 'none', lg: 'block'}}
          position={'relative'}>
          <Stepper
            gap={'0px'}
            index={indexProgress}
            sx={{
              '.chakra-step__indicator': {
                bg: '#D9D9D9',
                border: '0px',
                w: '19px',
                h: '19px',
              },
              '.chakra-step': {
                gap: '0px',
              },
              '.chakra-step__indicator[data-status="complete"]': {
                backgroundColor: '#C9D7EA !important',
              },
              '.chakra-step__separator': {
                m: '0px !important',
              },
              '.chakra-step__title[data-status="active"],.chakra-step__title[data-status="complete"]':
                {
                  color: '#096DD9',
                },
            }}>
            {dataQuestions?.progresses.map((step: any, index: any) => (
              <Step key={index}>
                <Box position={'relative'}>
                  <StepIndicator>
                    <StepStatus
                      complete={<Image src={CheckCompleteIcon} />}
                      active={<Image src={CheckActiveIcon} />}
                    />
                  </StepIndicator>
                  <Box
                    color={'#BFBFBF'}
                    flexShrink="0"
                    position={'absolute'}
                    top={'20px'}
                    left={'50%'}
                    transform={'translateX(-50%)'}
                    style={{textWrap: 'nowrap'}}>
                    <StepTitle style={{fontSize: '13px'}}>
                      {step === 'Nghe dịch' ? 'Xem lại tình huống' : step}
                    </StepTitle>
                  </Box>
                </Box>
                <StepSeparator />
              </Step>
            ))}
          </Stepper>
          <Icon
            position={'absolute'}
            right={'-100px'}
            top={'50%'}
            transform={'translateY(-50%)'}
            w={'24px'}
            h="24px"
            viewBox="0 0 24 24"
            cursor={'pointer'}
            sx={{
              path: {
                fill: '#000000',
              },
            }}
            onClick={() => {
              dispatch(updateIsShowReportErrorForm(true))
            }}>
            <ExclamationCircle />
          </Icon>
        </Box>
        {isShowHeaderBtn && (
          <Center
            position={'absolute'}
            right={0}
            borderRadius={'16px'}
            p={'12px 24px'}
            bg={getTextBtn()?.bg}
            gap={'12px'}
            cursor={'pointer'}
            shadow={
              '0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)'
            }
            _hover={{
              shadow: '0px 4px 8px 0px #ccc, 0px 2px 4px 0px #ccc',
            }}
            onClick={handleClickBtn}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              color={getTextBtn()?.color}>
              {getTextBtn()?.text}
            </Text>
            <Icon
              w={'24px'}
              h={'24px'}
              sx={{
                stroke:
                  currentQuestion.type === 'LV2_LISTEN_CONVERSATION' ||
                  currentQuestion.type ===
                    'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT'
                    ? statusHeaderBtn === 'complete'
                      ? 'white'
                      : '#8C8C8C'
                    : 'white',
              }}>
              <ArrowRight4 />
            </Icon>
          </Center>
        )}
      </Flex>
      <Modal
        title="Thoát trang"
        onOk={handleOke}
        open={isOpenModal}
        onCancel={handleCancelModal}>
        <Text>Quá trình ôn tập của bạn sẽ không được lưu lại</Text>
      </Modal>
    </Box>
  )
}

export default Header
